import { z } from "zod";

export const packingSlipSchema = z.object({
  id: z.number(),
  date: z.string(),
  signature: z.string(),
  signature_time: z.string(),
  comment: z.string(),
  status: z.string(),
  relation_id: z.number(),
  pickup_amount: z.number(),
  relation: z.object({
    id: z.string(),
    name: z.string(),
    city: z.string(),
    street: z.string(),
    house_number: z.string(),
    house_number_addition: z.string(),
    postal_code: z.string(),
    phone: z.string(),
  }),
  route: z.object({
    id: z.number(),
    date: z.string(),
    delta: z.number(),
    truck: z.object({
      id: z.number(),
      licence: z.string(),
      capacity: z.number(),
      title: z.string(),
      driver: z.object({
        id: z.number(),
        name: z.string(),
        username: z.string(),
      }),
    }),
  }),
  requests: z.object({
    id: z.number(),
    type: z.string(),
    invoice_status: z.string().optional().nullable(),
    relation: z.object({
      id: z.string(),
      name: z.string(),
    }),
    state: z.string(),
    work_order_number: z.string(),
    pickup_and_delivery_date: z.string(),
    in_out_storage: z.string(),
    updated_at: z.string(),
    freestock: z.boolean(),
    requestTires: z.object({
      id: z.number(),
      tire: z.object({
        id: z.number(),
        brand: z.string(),
        car_position: z.string(),
        ean: z.string(),
        label: z.string(),
      }),
    }),
    source: z.object({
      "... on Tire": z.object({
        id: z.string(),
        brand: z.string(),
      }),
      "... on Tireset": z.object({
        id: z.string(),
        type: z.string(),
        car: z.object({
          id: z.string(),
          licence: z.string(),
          additional_info: z.string(),
          label: z.string(),
        }),
        position: z.object({
          label: z.string(),
        }),
      }),
    }),
  }),
  deliverSticker: z.object({
    pdfUrl: z.string(),
  }),
  pickupSticker: z.object({
    pdfUrl: z.string(),
  }),
});

export const packingSlipListSchema = z.object({
  id: z.number(),
  date: z.string(),
  status: z.string(),
  relation: z.object({
    id: z.string(),
    name: z.string(),
  }),
  route: z.object({
    id: z.number(),
    truck: z.object({
      id: z.number(),
      licence: z.string(),
      title: z.string(),
    }),
  }),
});
